'use client';

import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import NextLink from 'next/link';
import { addCanalPlusGTMClass, prepareImagePath } from 'services/lib/util';
import Image from 'next/image';
import { Title } from '../../title';
import { RectangleArrow } from '../../icons/rectangle-arrow';

const ACFtop10BlockSlider = ({ data }) => {
  const { title, subtitle, top10 } = data;

  return (
    <section className="topTen px-0">
      <div className="topTen__header mb-4 flex items-center justify-between px-0 xmd:mb-6">
        <Title text={title} className="!mb-0 px-0" />
        
        <div className="flex items-center gap-2 px-0">
          <div id="previousButton" className="swiper-button-prev relative static mt-0 h-auto w-auto shrink-0 px-0 after:hidden">
            <RectangleArrow />
          </div>
          <div id="nextButton" className="swiper-button-next relative static mt-0 h-auto w-auto shrink-0 px-0 after:hidden">
            <RectangleArrow />
          </div>
        </div>
      </div>

      {subtitle && (
        <p className="subtitle mb-4 px-0 text-[1rem] leading-[1.5] text-secondary xmd:mb-[26px]">
          {subtitle}
        </p>
      )}

      {top10 != null && Array.isArray(top10) && top10.length > 0 && (
        <Swiper
          navigation={{
            prevEl: '.swiper-button-prev',
            nextEl: '.swiper-button-next',
          }}
          modules={[Navigation]}
          spaceBetween={16}
          freeMode={true}
          slidesPerView={'auto'}
          pagination={{ clickable: true }}
          className="px-0"
        >
          {top10.map((item, i) => {
            const imageNode = item?.image?.node;
            const sourceUrl = imageNode?.sourceUrl;

            return (
              <SwiperSlide className="item px-0" key={item.link || i}>
                <div className="cover relative h-full w-full px-0">
                  <span className="counter px-0"> {i + 1} </span>
                  
                  {sourceUrl && (
                    <NextLink
                      href={item.link}
                      passHref
                      target="_blank"
                      className={addCanalPlusGTMClass(item.link)}
                    >
                      <div className="imageWrapper relative h-full w-full overflow-hidden px-0">
                        <Image
                          src={prepareImagePath(sourceUrl)}
                          className="coverImage object-cover px-0"
                          alt={imageNode?.altText || imageNode?.title || `Top ${i + 1}`}
                          title={imageNode?.title}
                          fill
                          sizes="(max-width: 768px) 85vw, 25vw"
                        />
                      </div>
                    </NextLink>
                  )}
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      )}
    </section>
  );
};

export default ACFtop10BlockSlider;